module.exports = __webpack_public_path__ + "img/globo.0535dc69.png";